import Zone from "@insite/client-framework/Components/Zone";
import PageModule from "@insite/client-framework/Types/PageModule";
import PageProps from "@insite/client-framework/Types/PageProps";
import Page from "@insite/mobius/Page";
import * as React from "react";

const AccountSummaryPage = ({ id }: PageProps) => {
    return (
        <Page data-test-selector="account-summary">
            <Zone contentId={id} zoneName="Content"></Zone>
        </Page>
    );
};

const pageModule: PageModule = {
    component: AccountSummaryPage,
    definition: {
        hasEditableUrlSegment: true,
        hasEditableTitle: true,
        pageType: "Content",
    },
};

export default pageModule;

/**
 * @deprecated Use string literal "AccountSummaryPage" instead of this constant.
 */
export const AccountSummaryPageContext = "AccountSummaryPage";
